import React from 'react';
import _ from 'lodash';
import {
  setMapView,
  setMapStyle,
  setPosterStyle,
  setPosterLayout,
  setMapLabels,
  setMapResolution,
  setDeviceType,
} from '../actions';
import { coordToPrettyText, getPosterLook } from '../util';
import { Icon, Button } from 'antd';
import TabView from './TabView';
import MediaQuery from 'react-responsive';
import GeoSearch from './GeoSearch';
import PosterSizeSelect from './PosterSizeSelect';
import OrientationSelect from './OrientationSelect';
import PosterLabelInputs from './PosterLabelInputs';
import PosterStyleSelect from './PosterStyleSelect';
import MapStyleSelect from './MapStyleSelect';
import ResolutionSelect from './ResolutionSelect';
import DeviceSelect from './DeviceSelect';
import CONST from '../constants';
import Alert from './Alert';
import cities from '../util/cities.json';

const AlvarMapDesignPanel = React.createClass({
  render() {
    const { globalState } = this.props;
    const mapItem = globalState.cart[globalState.editCartItem];

    return (
      <div className={`AlvarMapDesignPanel ${this.props.className}`}>
        <MediaQuery maxWidth={CONST.SCREEN_SM}>
          {(matches) => {
            if (matches) {
              return this._renderNarrowView(mapItem);
            } else {
              return this._renderWideView(mapItem);
            }
          }}
        </MediaQuery>

        {/*
        <div className="AlvarMapDesignPanel__recommend">
          <h3>Try one of our picks</h3>
          <CityButtonList onButtonClick={this._onCityButtonClick} />
        </div>
        */}
      </div>
    );
  },

  _renderNarrowView(mapItem) {
    return <div className="AlvarMapDesignPanel__narrow">
      <div className="AlvarMapDesignPanel__narrow-spacer"></div>
      <TabView onClose={this._onTabViewClose} selected={this.props.isOptionsOpen ? 0 : null}>
        <TabView.Panel className="AlvarMapDesignPanel__location-section" header="Options">
          {this._renderLocationAndStylePanel(mapItem)}
        </TabView.Panel>
      </TabView>
    </div>;
  },

  _renderWideView(mapItem) {
    return <div className="AlvarMapDesignPanel__wide">
      {this._renderLocationAndStylePanel(mapItem)}

    </div>;
  },

  _renderLocationAndStylePanel(mapItem) {
    const posterLook = getPosterLook(mapItem.posterStyle);

    return <div className="AlvarMapDesignPanel__group">
      <div className="AlvarMapDesignPanel__group">

        <h1>Style your background</h1>

        <h4>Map location</h4>
        <div className="AlvarMapDesignPanel__geo-and-random">
          <GeoSearch
            onInputChange={this._onGeoSearchInputChange}
            onChange={this._onGeoSearch}
          />
          <Button onClick={this._onRandomClick}>Random</Button>
        </div>
        <p className="AlvarMapDesignPanel__label">
          You can also zoom and drag the map to any location.
        </p>

      </div>

      <div className="AlvarMapDesignPanel__group">
        <h4>Map color</h4>
        <MapStyleSelect
          showStyles={posterLook.allowedMapStyles}
          selected={mapItem.mapStyle}
          onChange={this._onMapStyleChange}
        />
      </div>

      <div className="AlvarMapDesignPanel__group">
        <h4>Resolution</h4>
        <DeviceSelect
          defaultValue={mapItem.device}
          onChange={this._onDeviceChange}
        />
        {
          mapItem.device !== 'custom'
            ? null
            : <ResolutionSelect
                defaultWidth={mapItem.resolution.width}
                defaultHeight={mapItem.resolution.height}
                onChange={this._onMapResolutionChange}
              />
        }
      </div>
    </div>;
  },

  _renderSizePanel(mapItem) {
    return <div className="AlvarMapDesignPanel__group">
      <div className="AlvarMapDesignPanel__info">
        <Alert>
          <Icon type="picture" />
          <p>Our posters fit to standard frames which you can find anywhere.</p>
        </Alert>
      </div>

      <div className="AlvarMapDesignPanel__group">
        <h4>Size</h4>
        <PosterSizeSelect
          orientation={mapItem.orientation}
          selected={mapItem.size}
          onChange={this._onSizeChange}
        />
      </div>

      <div className="AlvarMapDesignPanel__group AlvarMapDesignPanel__orientation-select">
        <h4>Layout</h4>
        <OrientationSelect selected={mapItem.orientation} onChange={this._onOrientationChange} />
      </div>
    </div>;
  },

  _renderLabelsPanel(mapItem) {
    const posterLook = getPosterLook(mapItem.posterStyle);

    return <div className="AlvarMapDesignPanel__group">
      <PosterLabelInputs dispatch={this.props.dispatch} labels={{
        enabled: mapItem.labelsEnabled,
        showLabels: posterLook.labels,
        header: mapItem.labelHeader,
        smallHeader: mapItem.labelSmallHeader,
        autoUpdateCoordinates: mapItem.autoUpdateCoordinates,
        text: mapItem.labelText,
      }} />
    </div>;
  },

  _onGeoSearch(result) {
    const lat = result.geometry.location.lat;
    const lng = result.geometry.location.lng;

    this.props.dispatch(setMapView({
      center: {
        lat: lat,
        lng: lng,
      },
      zoom: 11,
    }));

    this.props.dispatch(setMapLabels({
      header: result.city,
      smallHeader: result.country,
      text: coordToPrettyText({ lat, lng }),
    }));

  },

  _onDeviceChange(obj) {
    this.props.dispatch(setDeviceType(obj.value));

    if (obj.resolution !== null) {
      this.props.dispatch(setMapResolution(obj.resolution));
    }
  },

  _onRandomClick() {
    const city = _.sample(cities);
    const [lat, lng] = city.latLng;

    this.props.dispatch(setMapView({
      center: { lat: lat + _.random(0, 0, true), lng: lng + _.random(-0, 0, true) },
      zoom: 11,
    }));

    this.props.dispatch(setMapLabels({
      header: city.name,
    }));
  },

  _onGeoSearchInputChange(input) {

  },

  _onCityButtonClick(item) {
    this.props.dispatch(setMapView({
      center: { lat: item.lat, lng: item.lng },
      zoom: item.zoom
    }));

    this.props.dispatch(setMapLabels({
      header: item.header,
      smallHeader: item.smallHeader,
      text: coordToPrettyText({ lat: item.lat, lng: item.lng }),
    }));
  },

  _onTabViewClose() {
    this.props.onOptionsClose();
  },

  _onMapStyleChange(value) {
    this.props.dispatch(setMapStyle(value));
  },

  _onMapResolutionChange(value) {
    this.props.dispatch(setMapResolution(value));
  },

  _onPosterStyleChange(value) {
    this.props.dispatch(setPosterStyle(value));
  },

  _onOrientationChange(value) {
    this.props.dispatch(setPosterLayout({
      orientation: value,
    }));
  },

  _onSizeChange(value) {
    this.props.dispatch(setPosterLayout({
      size: value,
    }));
  },
});

export default AlvarMapDesignPanel;



// WEBPACK FOOTER //
// ./src/components/AlvarMapDesignPanel.js